const upsertOptimisticMessage = (messages = [], message) => {
   const existingIndex = messages.findIndex((candidate) => String(candidate._id) === String(message._id));
   const optimistic = {
      ...(existingIndex >= 0 ? messages[existingIndex] : message),
      ...message,
      pending: true,
      failed: false
   };

   if (existingIndex < 0) return [...messages, optimistic];
   return messages.map((candidate, index) => index === existingIndex ? optimistic : candidate);
};

const markOptimisticMessage = (messages = [], id, patch) => messages.map((message) =>
   String(message._id) === String(id) ? { ...message, ...patch } : message
);

const removeOptimisticMessage = (messages = [], id) => messages.filter((message) => String(message._id) !== String(id));

const reconcileOptimisticMessages = (messages = [], frames = []) => {
   const persistedIds = new Set(frames.map((frame) => String((frame.content && frame.content._id) || frame.id)));
   return messages.filter((message) => !persistedIds.has(String(message._id)));
};

export {
   markOptimisticMessage,
   reconcileOptimisticMessages,
   removeOptimisticMessage,
   upsertOptimisticMessage
};
